/* tslint:disable */
/* eslint-disable */
export enum ProxyBidCreationConflictType {
  LotNotAvailable = 'lot_not_available',
  ProxyBidsNotActive = 'proxy_bids_not_active',
  BidAmountLowerThanStartingBid = 'bid_amount_lower_than_starting_bid',
  BidAmountNotAlignedToBidIncrements = 'bid_amount_not_aligned_to_bid_increments',
  BidderTermsAndConditionsNotAccepted = 'bidder_terms_and_conditions_not_accepted'
}
